<app-langding-page-nav-bar *ngIf="show"></app-langding-page-nav-bar>
<div class="app-container" [class.app-container--fluid]="isFullWidth">
  <router-outlet></router-outlet>
</div>
